// extracted by mini-css-extract-plugin
export default {"terms":"termsConditions_terms__QynjB","sub_terms":"termsConditions_sub_terms__RBOI2","terms_content":"termsConditions_terms_content__Ip--S"};